import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Grid from '@material-ui/core/Grid';
import Question from './Question';
import QuestionCount from './QuestionCount';
import AnswerOption from './AnswerOption';
import NextButton from './QuizButtons/NextButton';
import BackButton from './QuizButtons/BackButton';
import FinishButton from './QuizButtons/FinishButton'

import QnA from './api/QnA.json'
//import PreventReload from '../../modules/preventReload';

//問題組み立て
class Quiz extends React.Component {
  constructor(props){
    super(props)
    this.renderAnswerOptions = this.renderAnswerOptions.bind(this)
    this.onAnswerSelected = this.onAnswerSelected.bind(this)
    this.next = this.next.bind(this)
    this.back = this.back.bind(this)
    this.whenUnload = this.whenUnload.bind(this);
    this.unload = this.unload.bind(this)
  }

  next() {
    this.scrollToTop(250)
    this.props.next(this.props.selectedAnswer);
  }

  back(){
    this.scrollToTop(250)
    this.props.back(this.props.selectedAnswer);
  }

  scrollToTop(ms) {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, ms);
  }

  onAnswerSelected (event){
    const selectedAnswer = event.currentTarget.value
    this.props.setSelectedAnswer(selectedAnswer)
  }

  renderAnswerOptions(key) {
    return (
      <AnswerOption
        key={key.content}
        answerContent={key.content}
        answerType={key.type}
        questionId={this.props.questionId}
        onAnswerSelected={this.onAnswerSelected}
        selectedAnswer={this.props.selectedAnswer}
      />
    );
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.whenUnload);
    window.addEventListener('unload', this.unload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.whenUnload);
  }

  whenUnload(event) {
    const reloadMsg = 'テスト中に更新はできません。\n更新するとテストを終了いたします。';
    event.returnValue = reloadMsg;
    return reloadMsg;
  }

  unload() {
    this.props.finishFunc(this.props.selectedAnswer)
  }

  render(){
    return (
      <ReactCSSTransitionGroup
        className="container"
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
      >


        <Grid container spacing={3} >
          <Grid item xs={2} />
          <Grid item xs={8} >
            <QuestionCount
              counter={this.props.questionId}
              total={this.props.questionTotal}
              changeQuestionId={this.props.changeQuestionId}
            />            
          </Grid>
          <Grid item xs={2} >
            <FinishButton onClick={this.props.finishButtonFunc} />
          </Grid>
          <Grid item xs={12} >
            <Question content={this.props.question} logo={this.props.logo} logoheight={this.props.logoheight}/>
          </Grid>

          <Grid item xs={12} >
            <ul className="answerOptions">
              {this.props.answerOptions.map(this.renderAnswerOptions)}
            </ul>
          </Grid>
          { this.props.questionId !== 1 ? <Grid item xs={2}><BackButton clickFunc={this.back} /> </Grid> : <Grid item xs={2} /> }
          <Grid item xs={8} />
          { this.props.questionId !== QnA.QnA.length ? <Grid item xs={2}><NextButton clickFunc={this.next} /> </Grid> : <Grid item xs={2} /> }
        </Grid>
      </ReactCSSTransitionGroup>
    );
  }
}

Quiz.propTypes = {
  selectedAnswer: PropTypes.string.isRequired,
  setSelectedAnswer: PropTypes.func.isRequired,
  answerOptions: PropTypes.array.isRequired,
  question: PropTypes.string.isRequired,
  questionId: PropTypes.number.isRequired,
  questionTotal: PropTypes.number.isRequired,
  changeQuestionId: PropTypes.func.isRequired,
  logo:PropTypes.number.isRequired,
  next: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
  hasDone: PropTypes.bool.isRequired
};

export default Quiz;



// WEBPACK FOOTER //
// ./src/components/quiz/Quiz.js